import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Navbar,
  Container,
  Nav,
  FormControl,
  Button,
  Form,
  DropdownButton,
  Dropdown,
  ButtonGroup,
} from "react-bootstrap";
import { user_logout } from "../../redux/actions";
import useWindowDimensions from "../../util/useWindowDimensions";
import NavBarLinks from "../../components/navBarLinks";
import navBarData from "../../mockData/Navbar.json";
import { Link, useHistory } from "react-router-dom";

export default function PageNavbar(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const globalState = useSelector((state) => state);
  const { _, width } = useWindowDimensions();
  const [opaque, setOpaque] = useState(false);
  document.addEventListener("scroll", () => {
    if (window.scrollY > 0) setOpaque(true);
    else setOpaque(false);
  });

  function navBarClassHelper(opaque, pageWidth, whereTo) {
    if (whereTo === "bg") {
      if (pageWidth < 992) {
        return "light";
      } else {
        if (opaque) return "light";
      }
    } else {
      if (pageWidth < 992) {
        return "light";
      } else {
        if (opaque) return "light";
        else return "dark";
      }
    }
  }

  function navBarHelper(navBarData) {
    return (
      navBarData &&
      navBarData.map((item, index) => {
        if (globalState.isAuthenticated) {
          if (index !== 2) {
            return <NavBarLinks key={index} item={item} />;
          }
        } else {
          return <NavBarLinks key={index} item={item} />;
        }
      })
    );
  }

  function navbarDropDownClick(e) {
    history.push("/");
    dispatch(user_logout());
  }

  function navbarRoute() {
    history.push("/userInfo");
  }

  return (
    <Navbar
      sticky="top"
      // variant={navBarClassHelper(opaque, width, "variant")}
      variant="light"
      bg={navBarClassHelper(opaque, width, "bg")}
      expand="lg"
      collapseOnSelect
    >
      <Container fluid>
        <Navbar.Brand>
          <Link to="/">
            <img
              alt="devunity-icon"
              src="https://cdn.discordapp.com/attachments/894110061859852352/896350323260661770/devUnity.gif"
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{" "}
            DevUnity
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="me-auto my-2 my-lg-0 fw-bolder">
            {/* {navBarData &&
              navBarData.map((item, index) => {
                if (globalState.isAuthenticated) {
                  if(item !== 2) {
                    return <NavBarLinks key={index} item={item} />;
                  }
                }
                else return <NavBarLinks key={index} item={item} />;
              })} */}
            {navBarData && navBarHelper(navBarData)}
          </Nav>
          {/* <Form className="d-flex">
            <FormControl
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
            />
            <Button variant="outline-success">Search</Button>
          </Form> */}
          <Nav className="my-2 my-lg-0 fw-bolder">
            <Form className="d-flex">
              <FormControl
                type="search"
                placeholder="Search"
                className="me-2"
                aria-label="Search"
              />
              <Button variant="outline-success">Search</Button>
            </Form>
            {globalState.isAuthenticated && (
              <>
                <NavBarLinks
                  item={{ routeName: "New Post", link: "/newArticle" }}
                />
                <DropdownButton
                  as={ButtonGroup}
                  key="UserName"
                  id="dropdown-variants-Secondary"
                  variant="secondary"
                  title={"Hi " + globalState.user.first_name}
                >
                  <Dropdown.Item eventKey="1" onClick={navbarRoute}>
                    {globalState.user.first_name}
                  </Dropdown.Item>
                  {/* <Dropdown.Item eventKey="2">Setting</Dropdown.Item> */}
                  <Dropdown.Divider />
                  <Dropdown.Item eventKey="4" onClick={navbarDropDownClick}>
                    Log Out
                  </Dropdown.Item>
                </DropdownButton>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
